type VerticalInstantiationsResponse = {
	readonly edges?: ReadonlyArray<{
		readonly node?: {
			readonly id?: string | null;
			readonly type?: string | null;
			readonly status?: string | null;
		} | null;
	} | null> | null;
} | null;

export const extractHamVerticalInstantiationStatus = (
	verticalInstantiations: VerticalInstantiationsResponse | undefined,
): string | null =>
	verticalInstantiations?.edges?.find((edge) => {
		const node = edge?.node;
		return node?.type === 'HAM' && node.id !== '';
	})?.node?.status ?? null;
